import CrmApi from './CrmApi'
var Api = new CrmApi({
  url: process.env.BASE_API
})

export default Api



// WEBPACK FOOTER //
// ./src/api/API.js